// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3t2hN","error":"Textarea_error__2J_nV","readonly":"Textarea_readonly__SjjUn","disabled":"Textarea_disabled__3Hed7"};